import React from 'react'
import {
  LoaderSwitcher,
  MerchantLoader,
  StripeConnectLoader
} from 'router/Loaders'
import { MerchantIntegrationsLoader } from 'router/Loaders/MerchantIntegrationsLoader'
import { MerchantIntegrationSettingsLoader } from 'router/Loaders/MerchantIntegrationSettingsLoader'
import { IntegrationsLoader } from 'router/Loaders/IntegrationsLoader'
import { isAdmin, isManager, useSession } from 'packages/@slerp/accounts'
import StaffLayout from 'components/Layout/StaffLayout'
import AdminLayout from 'components/Layout'

export const LayoutWrapper = () => {
  const { user } = useSession()

  const isAdminUser = isAdmin(user)
  const isManagerUser = isManager(user)

  if (isAdminUser) {
    return (
      <MerchantLoader>
        {(isParentLoaded) => (
          <MerchantIntegrationsLoader isParentLoaded={isParentLoaded}>
            {(isParentLoaded) => (
              <MerchantIntegrationSettingsLoader
                isParentLoaded={isParentLoaded}
              >
                {(isParentLoaded) => (
                  <IntegrationsLoader isParentLoaded={isParentLoaded}>
                    {(isParentLoaded) => (
                      <StripeConnectLoader isParentLoaded={isParentLoaded}>
                        {(isParentLoaded) => (
                          <LoaderSwitcher isParentLoaded={isParentLoaded}>
                            <AdminLayout />
                          </LoaderSwitcher>
                        )}
                      </StripeConnectLoader>
                    )}
                  </IntegrationsLoader>
                )}
              </MerchantIntegrationSettingsLoader>
            )}
          </MerchantIntegrationsLoader>
        )}
      </MerchantLoader>
    )
  }

  // No integration-settings/status Loaders here: their Monolith resolvers
  // only authorise admin/superadmin, so for a manager they would only fail
  // and toast on every load.
  if (isManagerUser) {
    return (
      <MerchantLoader>
        {(isParentLoaded) => (
          <MerchantIntegrationsLoader isParentLoaded={isParentLoaded}>
            {(isParentLoaded) => (
              <LoaderSwitcher isParentLoaded={isParentLoaded}>
                <StaffLayout />
              </LoaderSwitcher>
            )}
          </MerchantIntegrationsLoader>
        )}
      </MerchantLoader>
    )
  }

  return (
    <MerchantLoader>
      {(isParentLoaded) => (
        <LoaderSwitcher isParentLoaded={isParentLoaded}>
          <StaffLayout />
        </LoaderSwitcher>
      )}
    </MerchantLoader>
  )
}
